<template>
  <div v-cloak>
    <div class="">
      <div class="">
        <div class="row">
          <div class="col-md-6">
            <div class="input-group col-xs-12">
              <input type="text" class="form-control" ref="code" autofocus placeholder="Código de tarjeta" :readonly="readOnlyUser" v-model="codeCardIn">
              <span class="input-group-append">
                <button v-if="hasPermission([consts.permissions.READ_USERS]) && ![1359, 1360, 2341, 2342].includes(user.id)" class="btn btn-secondary" type="button" v-on:click="openSearchModal()">
                  <i class="fa fa-search" />
                </button>
                <button class="btn btn-primary" type="button" v-on:click="clearInput">Limpiar</button>
              </span>
            </div>
            <br>
            <div class="card recent-sale menu-tile">
              <div class="px-3">
                <b-row align-v="baseline">
                  <b-col sm="12" lg="3" class="mr-auto p-3 paddingChangeBottom">
                    <label>Productos</label>
                  </b-col>
                  <b-col sm="12" lg="9" class="p-3 paddingChangeTop">
                    <div class="d-flex flex-row">
                      <b-input-group>
                          <b-input  type="text" id="input-product" ref="products" v-model="searchProduct" placeholder="Nombre del producto"></b-input>
                          <b-input-group-append class="border-0">
                            <button class="btn btn-primary" type="button" @click="clearSearchProuct">
                              <i class="fa fa-eraser" aria-hidden="true"></i>
                            </button>
                          </b-input-group-append>
                        </b-input-group>
                      <div class="d-flex flex-row justify-content-end px-2">
                        <a-dropdown placement="bottomRight" :trigger="['click']">
                         <button type="button" class="btn btn-light">
                           <i class="fe fe-more-vertical" />
                         </button>
                         <a-menu slot="overlay">
                            <a-menu-item @click="viewProduct(true)">
                               <i class="fa fa-th-large fa-lg"/><span class="px-2">Cuadrícula</span>
                            </a-menu-item>
                            <a-menu-item @click="viewProduct(false)">
                              <i class="fa fa-th-list fa-lg" /><span class="px-2">Lista</span>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </div>
                  </div>
                  </b-col>
                </b-row>
              </div>
              <div v-if="isDataLoaded" role="tablist" class="pb-3">
                <div>
                  <b-card no-body class="ml-2 mr-2 mt-1 mb-auto">
                    <b-col col lg="3" class="p-0"><b-button block v-b-toggle="'collapsableCategoriesX'" variant="link" class="m-auto text-left">
                      Todos ({{filteredProducts.length}}) </b-button></b-col>
                    <b-collapse
                      :id="'collapsableCategoriesX'"
                      :accordion="'categoryX'"
                      role="tabpanel"
                      visible
                    >
                    <!-- Etiqueta All Contiene todos los productos -->
                      <div class="container-fluid" v-if="isGrid">
                        <div class="row">
                          <div class="col-sm-12 d-flex">
                            <div :class="$style.items">
                              <div :class="$style.item" v-for="(product, id) in filteredProducts" v-bind:key="id">
                                <div v-on:click="addProduct(product)" :class="!product.active ? $style.cardProductBrightness : ''">
                                  <div v-if="inventoryCheck" class="text-break" style="text-align: center;"><b>{{product.quantity}}</b></div>
                                  <img :src="`${product.pathAvatar}?tr=w-120`"
                                  @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                                  alt="Image" />
                                  <div  :class="product.active ? 'text-gray-6' : 'text-white'">
                                    <div class="text-break"><b>{{product.name}}</b></div>
                                    <div>{{ currencyFormat(product.cost) }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <b-row v-else class="mt-1 px-2">
                        <b-col>
                          <b-table v-if="filteredProducts.length > 0" striped hover :fields="columnsProduct"  :items="filteredProducts" @row-clicked="addProduct" head-variant="light" responsive style="cursor: pointer;">
                          </b-table>
                          <empty-table v-else/>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-card>
                </div>
                <!-- Contiene for para cada categoria del collapse -->
                <div v-for="(item,index) in categories" v-bind:key="item.id">
                  <b-card v-if="index !== categories.length-1" no-body class="ml-2 mr-2 mb-auto">
                    <b-col col lg="5" class="p-0"><b-button block v-b-toggle="'collapsableCategories'+index" variant="link" class="m-auto text-left" @click="productByCategory(item.name)">{{ item.name }} ({{ item.quantity }})</b-button></b-col>
                    <b-collapse
                      :id="'collapsableCategories'+index"
                      :accordion="'category'+index"
                      role="tabpanel"
                    >
                      <div class="container-fluid" v-if="isGrid">
                        <div class="row">
                          <!-- For para agregar productos que tengan esa categoría -->
                          <div :class="$style.items" v-for="(product, id) in filteredProducts" v-bind:key="id">
                            <div :class="$style.item" v-if="existCategoryInProduct(product.categories , item)">
                              <div class="col-sm-16">
                                <div v-on:click="addProduct(product)" :class="!product.active ? $style.cardProductBrightness : ''">
                                  <div v-if="inventoryCheck" class="text-break" style="text-align: center;"><b>{{product.quantity}}</b></div>
                                  <img :src="`${product.pathAvatar}?tr=w-120`"
                                  @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                                  alt="Image" />
                                  <div  :class="product.active ? 'text-gray-6' : 'text-white'">
                                    <div class="text-break"><b>{{product.name}}</b></div>
                                    <div>{{ currencyFormat(product.cost) }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <b-row v-else class="m-3">
                        <b-col>
                          <b-table v-if="itemProductCategory.length > 0" striped hover :fields="columnsProduct"  :items="itemProductCategory" @row-clicked="addProduct" head-variant="light" responsive style="cursor: pointer;">
                          </b-table>
                          <empty-table v-else/>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-card>
                  <b-card v-else no-body class="ml-2 mr-2 mb-1">
                    <b-col col lg="5" class="p-0"><b-button block v-b-toggle="'collapsableCategories'+index" variant="link" class="m-auto text-left" @click="productFinalByCategory(item.name)">
                      {{ item.name }}  ({{ item.quantity }})</b-button></b-col>
                    <b-collapse
                      :id="'collapsableCategories'+index"
                      :accordion="'category'+index"
                      role="tabpanel"
                    >
                      <div class="container-fluid" v-if="isGrid">
                        <div class="row">
                          <!-- For para agregar productos que tengan esa categoría -->
                          <div :class="$style.items" v-for="(product, id) in filteredProducts" v-bind:key="id">
                            <div :class="$style.item" v-if="existCategoryInProduct(product.categories , item)">
                              <div class="col-sm-16">
                                <div v-on:click="addProduct(product)" :class="!product.active ? $style.cardProductBrightness : ''">
                                  <div v-if="inventoryCheck" class="text-break" style="text-align: center;"><b>{{product.quantity}}</b></div>
                                  <img :src="`${product.pathAvatar}?tr=w-120`"
                                  @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                                  alt="Image" />
                                  <div  :class="product.active ? 'text-gray-6' : 'text-white'">
                                    <div class="text-break"><b>{{product.name}}</b></div>
                                    <div>{{ currencyFormat(product.cost) }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <b-row v-else class="m-3">
                        <b-col>
                          <b-table v-if="itemFinalProductCategory.length > 0" striped hover :fields="columnsProduct"  :items="itemFinalProductCategory" @row-clicked="addProduct" head-variant="light" responsive style="cursor: pointer;">
                          </b-table>
                          <empty-table v-else/>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="card">
                <!-- <h5 class="card-header">
                  {{ invoiceEdited.id ? 'Editar factura' : 'Nueva venta' }}
                </h5> -->
                <div class="card-body" v-show="userSelected">
                  <div class="d-flex flex-sm-column flex-lg-row" :class="$style.userSelected">
                    <div>
                      <img :src="`${userSelected.pathAvatar}?tr=w-300`"
                      @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                      class="rounded-circle img-thumbnail">
                    </div>
                    <div class="pl-3 pt-3">
                      <h5><b>NOMBRE: </b>{{ getFullName(userSelected) }}</h5>
                      <h5 v-show="userSelected.grade"><b>GRADO: </b>{{ userSelected.grade ? userSelected.grade.name: 'N/A'}}</h5>
                      <h5><b>SALDO: </b>{{ currencyFormat(userSelected.balance) }}</h5>
                      <h5 v-if="userSelected.controlParental && this.userSelected.controlParental.buyLimit > 0"><b>LÍMITE: </b>{{ currencyFormat((userSelected.controlParental.buyLimit - userSelected.totalInvoices )) }}</h5>
                      <h5 v-if="Object.prototype.hasOwnProperty.call(this.userSelected, 'credit') && this.userSelected.credit >= 0"><b>CRÉDITO DISPONIBLE: </b>{{ currencyFormat((userSelected.credit )) }}</h5>
                      <h5 v-show="comboCheck"><b>{{comboName.toUpperCase()}}S: </b>{{ userSelected.combos }}</h5>
                    </div>
                  </div>
                  <div class="table-responsive pt-3"  v-show="comboCheck">
                    <table class="table table-stripped">
                      <thead>
                        <tr>
                          <th class="align-middle">
                            {{ comboName.toUpperCase() }}
                          </th>
                          <th>
                            <vue-number-input controls style="width: 8rem" v-model="comboAmount" :min="0" :max="combosLeftToBuy" @change="updateCombosLeft" ></vue-number-input>
                          </th>
                          <th class="align-middle">
                            Saldo de {{ comboName.toLowerCase() }}s final : {{ combosLeft }}
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="table-responsive pt-3">
                    <table class="table table-stripped">
                      <thead>
                        <tr>
                          <th>
                            Producto
                          </th>
                          <th>
                            Cantidad
                          </th>
                          <th>
                            Valor unitario
                          </th>
                          <th>
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="productToBuy in productsToBuy" v-bind:key="productToBuy.id">
                          <td>
                            {{ productToBuy.name }}
                            <b-button variant="outline-danger" v-on:click="removeProduct(productToBuy)">
                              <i class="fa fa-times-circle" />
                            </b-button>
                          </td>
                          <td>
                            <vue-number-input controls style="width: 8rem" v-model="productToBuy.quantityToBuy" :min="1" :max="productToBuy.quantityLeft" @change="updateProductsToBuy" v-if="inventoryCheck" ></vue-number-input>
                            <vue-number-input controls style="width: 8rem" v-model="productToBuy.quantityToBuy" :min="1" :max="999" @change="updateProductsToBuy" v-else ></vue-number-input>
                          </td>
                          <td>
                            {{ currencyFormat(productToBuy.cost) }}
                          </td>
                          <td>
                            {{ currencyFormat(productToBuy.subtotal) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br>
                  <div class="alert alert-warning" role="alert" v-show="!canToBuy() && this.total !== 0">
                    El valor de la compra supera el saldo actual y/o del valor máximo por día establecido en control parental
                  </div>
                  <div class="alert alert-warning" role="alert" v-show="!enoughProducts()">
                    La cantidad de productos a comprar supera la cantidad disponible
                  </div>
                  <div class="pull-right">
                    <b style="font-size: 1.2rem" class="mr-2">TOTAL: {{currencyFormat(total)}}</b>
                    <button type="submit" :disabled="!(checkProducts() && canToBuy() && enoughProducts() && !isBuying)" class="btn btn-success mr-2" v-on:click="buyProducts">Comprar</button>
                  </div>
                </div>
                <div class="card-body" v-show="!userSelected">
                  <div class="col-12 pl-0" v-if="cashBoxState.isClosed && cashBoxCheck">
                    <i class="fa fa-lock mr-2"/><span class="ml-1">La caja está cerrada. Solicita su apertura para comenzar las ventas</span>
                    <b-button @click="downloadReportCashBox()" squared variant="outline-success" pill class="ml-3" :class="{ 'mt-2': cashBoxState.isClosed }">
                      <i class="fe fe-download mx-1" /> Reporte
                    </b-button>
                  </div>
                    <div class="col-12 p-0" v-else>
                     <div class="d-flex flex-column flex-lg-row justify-content-between flex-wrap">
                       <span class="my-auto">Debe ingresar el código del estudiante</span>
                      <div class="d-flex justify-content-center my-2 my-lg-0" v-if="cashBoxCheck">
                        <b-button variant="outline-primary" class="mr-2" pill @click="updateCashBox(false)">
                          <i :class="cashBoxState.isPaused ? 'fa fa-play-circle': 'fa fa-pause-circle-o'" class="mr-2" />{{ cashBoxState.isPaused ? 'Reanudar' : 'Pausar' }}
                        </b-button>
                        <b-button variant="outline-danger" class="mr-2" pill @click="updateCashBox(true)">
                          <i class="fa fa-lock mr-2" />Cerrar
                        </b-button>
                        <b-button v-if="cashBoxState.isPaused || cashBoxState.isClosed" @click="downloadReportCashBox()" squared variant="outline-success" pill>
                          <i class="fe fe-download mr-1"></i>
                          Reporte
                        </b-button>
                      </div>
                     </div>
                       <small class="text-muted text-wrap m-0 p-0" v-if="cashBoxCheck">
                        {{cashBoxState.isPaused ? 'Caja en pausa. Para reanudar las ventas, haz clic o touch en el botón de reanudar.' : 'Si necesitas suspender la caja, haz clic o toca el botón de pausa.'}}
                      </small>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <h5 class="card-header">
                  Ventas recientes
                </h5>
                <div class="card-body">
                  <div style="width: 100%; overflow-x: scroll;" class="d-flex flex-row">
                    <div :class="$style.itemRecentSales" class="mr-3" v-for="sale in recentSales.slice().reverse() " v-bind:key="sale.idInvoice">
                      <h5>
                        {{ getFullName(sale.userName) }}
                        <div class="d-flex justify-content-around p-0 my-2">
                          <b-button class="rounded-sm" variant="outline-success" v-on:click="printInvoice(sale)">
                            <i class="fa fa-print" aria-hidden="true"></i>
                          </b-button>
                          <b-button class="rounded-sm" variant="outline-info" v-on:click="calculatorReturned(sale.totalTemp, sale.products, sale.consecutive)">
                            <i class="fa fa-calculator" aria-hidden="true"></i>
                          </b-button>
                          <b-button class="rounded-sm" variant="outline-primary" v-on:click="openModal(sale)">
                              <i :class="(sale.observation !== '' && sale.observation !== null && sale.observation !== undefined) ? 'fa fa-comment' : 'fa fa-comment-o'" />
                          </b-button>
                          <b-button class="rounded-sm" variant="outline-danger" v-on:click="checkRole(sale)">
                            <i class="fa fa-times-circle" />
                          </b-button>
                        </div>
                      </h5>
                      <div class="">
                        <!-- <h6 class="mb-2 text-muted">Factura {{sale.consecutive}}
                        </h6> -->
                        <h5 class="" v-for="product in sale.products" v-bind:key="product.id">
                          {{ product.quantity + " " +product.name }}
                        </h5>
                        <h5 v-if="sale.comboTemp > 0">
                          {{ sale.comboTemp }} {{ comboName.toUpperCase() }}S
                        </h5>
                        <div class="clearfix"></div>
                          <b>Total {{ currencyFormat(sale.totalTemp) }}</b>
                        <div v-if="sale.balance >= 0" class="alert" role="alert" v-bind:class="[sale.balance < 5100 ? 'alert-danger': 'alert-primary' ]">
                          Saldo actual <b>{{ currencyFormat(sale.balance) }}</b>
                        </div>
                        <div class="clearfix"></div>
                          <b v-if="sale.comboTemp > 0 && comboCheck">Total {{comboName}}s {{sale.comboTemp}}</b>
                        <div v-if="sale.combosLeft >= 0 && comboCheck" class="alert" role="alert" v-bind:class="[sale.combosLeft < 3 ? 'alert-danger': 'alert-primary' ]">
                          {{ comboName }}s restantes <b>{{ sale.combosLeft }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-observation" hide-footer hide-header size="md">
      <b-row class="my-3">
        <b-col sm="3">
          <label for="textarea-default">Observación:</label>
        </b-col>
        <b-col sm="9" class="pl-1">
          <b-form-textarea
          v-model="tempSaleData.observation"
            id="textarea-default"
            maxlength="250"
            placeholder="Ingrese la Observación"
            rows="3"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="p-auto mr-3" align-h="end">
        <b-col md="2">
          <b-button variant="primary" v-on:click="addObservation(tempSaleData)">Guardar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-search" hide-footer hide-header size="lg">
      <b-button pill variant="outline-transparent"  size="sm" class="float-right" v-on:click="closeSearchModal()"><i class="fa fa-times" aria-hidden="true"></i></b-button>
      <b-row class="m-3">
        <b-col>
          <userList @getCodeCard="getCodeCard" :properties="properties"/>
        </b-col>
      </b-row>
        <b-button size="sm" class="mx-auto d-block" v-on:click="closeSearchModal()">Cerrar</b-button>
    </b-modal>
    <b-modal id="modal-calculator" centered hide-footer hide-header size="md">
      <h3 class="mt-2 mb-3">Calcular cambio</h3>
      <span>Ingresa el monto con el que se efectuó el pago de la venta # {{ dataCalculator.consecutive }}.</span><br>
      <span>{{dataCalculator.listProducts}}. <b>Total compra: {{ currencyFormat(dataCalculator.moneyInvoice) }}</b></span>
      <div class="d-flex my-2 flex-column">
        <div class="d-flex mx-auto">
          <b-form-group id="moneyReturned" label="Pago:">
            <b-input-group style="height: 40px;" class="d-flex flex-nowrap justify-content-center">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
              </div>
              <money v-model="dataCalculator.moneyPay" v-bind="money" style="font-size: 1.5em; width: 160px !important"></money>
            </b-input-group>
          </b-form-group>
        </div>
        <small v-if="dataCalculator.moneyPay < 0" class="text-muted text-wrap m-0 p-0" style="font-size: 13px;">Para realizar un cálculo adecuado, recuerda que los valores deben ser positivos (no inferiores a cero).</small>
        <div class="d-flex mx-auto">
          <h4 class="mr-2">{{dataCalculator.moneyPay - dataCalculator.moneyInvoice > 0 ? 'Cambio' :' Faltante'}}: </h4>
          <i class="fa fa-money"  aria-hidden="true" style="font-size: 2rem;"><span class="mx-2">{{dataCalculator.moneyPay - dataCalculator.moneyInvoice > 0 ? currencyFormat( dataCalculator.moneyPay - dataCalculator.moneyInvoice) : currencyFormat((dataCalculator.moneyPay - dataCalculator.moneyInvoice )* -1)}}</span></i>
        </div>
      </div>
      <b-row class="mr-3 mt-2" align-h="end">
          <b-button variant="secondary" @click="()=>{dataCalculator.moneyPay = 0; this.$bvModal.hide('modal-calculator')}">Cerrar</b-button>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
  @media(max-width:768px) {
    .paddingChangeTop {
        padding-top: 0px;
    }
    .paddingChangeBottom {
        padding-bottom: 0px;
    }
  }
</style>
<script>
import store from 'store'
import moment from 'moment'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import axios from 'axios'
import { map, sum, find, remove } from 'lodash'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import { hasPermission, consts, currencyFormatPesos, showErrorMessage } from '@/services/utilities'
import userList from '@/components/custom/userList'
import emptyTable from '@/components/custom/cardEmptyList'
import { Money } from 'v-money'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'RestaurantSales',
  components: { VueNumberInput, userList, emptyTable, Money },
  data() {
    return {
      grades: {},
      categories: [],
      products: [],
      nProducts: 0,
      searchProduct: '',
      codeCardIn: '',
      userSelected: false,
      readOnlyUser: false,
      isBuying: false,
      productsToBuy: [],
      total: 0,
      recentSales: [],
      tempSales: [],
      tempSaleData: {
        observation: '',
      },
      invoiceEdited: {},
      timerId: 0,
      tempStorage: [],
      comboAmount: 0,
      combosLeft: 0,
      combosLeftToBuy: 0,
      comboCheck: false,
      comboName: '',
      inventoryCheck: false,
      creditCheck: false,
      properties: {
        create: false,
        hasColumns: true,
        columns: {
          cc: true,
          balance: true,
          actions: true,
        },
        searchOptions: {
          cc: true,
          name: true,
          lastName: true,
          grade: false,
          codeCard: true,
        },
        hasActions: true,
        actions: {
          information: true,
          select: true,
          rechargeBalance: true,
          rechargeCombos: true,
        },
        user: {
          downloadEnrollmentSheet: false,
          deleteUser: false,
        },
      },
      consts: consts,
      moment,
      columnsProduct: [
        { label: 'Producto', dataIndex: 'name', key: 'name' },
        { label: 'Precio', dataIndex: 'cost', key: 'cost' },
        { label: 'Disponible', dataIndex: 'quantity', key: 'quantity' },
      ],
      isGrid: true,
      itemProductCategory: [],
      itemFinalProductCategory: [],
      disabledProducts: [],
      role: '',
      money: {
        decimal: '',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false,
      },
      cashBoxState: {
        isPaused: false,
        isClosed: false,
        id: 0,
      },
      dataCalculator: {
        consecutive: 0,
        moneyInvoice: 0,
        moneyPay: 0,
        listProducts: '',
      },
      cashBoxCheck: false,
      timerProducts: 0,
    }
  },
  watch: {
    codeCardIn: function(val) {
      if (val.length > 2) {
        this.debounce(val, 500)
      };
    },
    searchProduct: function(newValue) {
      this.$nextTick(() => {
        if (this.$refs.products && this.$refs.products.$el) {
          this.$refs.products.$el.addEventListener('keydown', function(event) {
            if (event.keyCode === 13) {
              event.preventDefault()
            } else if (event.keyCode === 17 || (event.ctrlKey && event.keyCode === 74)) {
              event.preventDefault()
            }
          })
        }
      })
      clearTimeout(this.timerProducts)
      this.timerProducts = setTimeout(() => {
        if (/^\s+|\s+$/.test(newValue)) {
          this.$nextTick(() => {
            this.searchProduct = newValue.trim()
            if (this.$refs.products) {
              this.$refs.products.$el.value = this.searchProduct
            }
          })
        } else {
          this.updateProductsQuantity()
        }
      }, 500)
    },
  },
  beforeRouteEnter (to, from, next) {
    function getGrades() {
      return apiClient.get('/grades')
    }

    function getProducts() {
      // return apiClient.get('/products?active=0')
      return apiClient2.get('sales/products?active=0')
    }

    function getParams() {
      return apiClient2.get('/schoolParam/active')
    }

    function getCategories() {
      return apiClient.get('/products/categories')
    }

    function getRecentSales() {
      return apiClient.get('/invoices')
    }
    axios.all([getGrades(), getProducts(), getParams(), getCategories(), getRecentSales()])
      .then(axios.spread(function (grades, products, combos, categories, recentSales) {
        next((vm) => {
          vm.setDataGrades(null, grades.data.results.rows)
          vm.setDataProducts(null, products.data.data, false)
          vm.setDataParams(null, combos.data.data)
          vm.setDataCategories(null, categories.data)
          vm.setDataRecentSales(null, recentSales.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataGrades(err, [])
          vm.setDataProducts(err, [], false)
          vm.setDataParams(err, [])
          vm.setDataCategories(err, [])
          vm.setDataRecentSales(err, [])
        })
      })
  },
  methods: {
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    getCodeCard(codeCard, roles) {
      this.role = roles
      if (codeCard && codeCard.length > 2) {
        this.codeCardIn = codeCard
        this.productsToBuy = []
        this.total = 0
        this.$bvModal.hide('modal-search')
      } else {
        Toast.fire({
          icon: 'warning',
          title: 'El usuario no tiene asignada una tarjeta',
        })
        this.clearInput()
        this.$bvModal.hide('modal-search')
      }
    },
    calculatorReturned(total, products, consecutive) {
      this.dataCalculator.moneyInvoice = total
      this.dataCalculator.consecutive = consecutive
      this.dataCalculator.listProducts = (products.length > 0 ? 'Productos comprados: ' : 'Producto comprado:') + (products.map((item) => ` ${item.quantity} ${item.name}`).toString())
      this.dataCalculator.moneyPay = 0
      this.$bvModal.show('modal-calculator')
    },
    setDataGrades (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.grades = data
      }
    },
    setDataProducts (err, data, loaded) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        data.rows = data.rows.map((item) => ({ ...item, barCode: item.barCode ?? '' }))
        this.products = [...data.rows]
        if (loaded && this.userSelected !== false) {
          this.activeInactive(true, null, this.inventoryCheck)
        } else {
          this.activeInactive(false)
          this.$refs.code.focus()
        }
      }
    },
    setDataParams (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        if (data) {
          this.comboCheck = false
          for (const param of data) {
            if (param.key === consts.params.COMBO) {
              this.comboCheck = param.active
              this.comboName = param.value.toUpperCase()
              this.comboName = this.comboName[0].toUpperCase() + this.comboName.slice(1).toLowerCase()
            } else if (param.key === consts.params.INVENTORY) {
              this.inventoryCheck = param.active
            } else if (param.key === consts.params.CREDIT) {
              this.creditCheck = param.active
            } else if (param.key === consts.params.CASH_BOX) {
              this.cashBoxCheck = param.active
              this.getOpenCashBox()
            }
          }
        }
      }
    },
    setDataCategories (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.categories = data
        this.activeInactive(false)
        this.$refs.code.focus()
      }
    },
    setDataRecentSales(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        // Transforma el contenido de data para ser visualizado
        data.forEach(function(obj) {
          obj.products = obj.soldProducts
          delete obj.soldProducts
          obj.products.forEach(function(objsub) {
            objsub.name = objsub.product.name
            delete objsub.product
          })
          obj.userName = {
            firstName: obj.userInvoice.firstName,
            secondName: obj.userInvoice.secondName,
            firstLastName: obj.userInvoice.firstLastName,
            secondLastName: obj.userInvoice.secondLastName,
            cc: obj.userInvoice.cc,
          }
          delete obj.userInvoice
        })
        this.recentSales = data.reverse()
      }
    },
    updateProductsQuantity: function () {
      for (const i in this.categories) {
        let quantityProducts = 0
        for (const k in this.filteredProducts) {
          if (this.filteredProducts[k].categories.some(data => data.name === this.categories[i].name)) {
            quantityProducts += 1
          }
        }
        this.categories[i].quantity = quantityProducts
      }
    },
    async search(state) {
      const sentParams = {
        active: 0,
        idUser: this.userSelected.id,
      }
      await apiClient2.get('sales/products', { params: sentParams }).then(response => {
        this.setDataProducts(null, response.data.data, !state)
      }).catch((e) => {
        this.$notification.warning({
          message: 'Notificación',
          description:
          showErrorMessage(e),
        })
      })
    },
    // Convert to lowercase(including special characters)
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    getFullName(user) {
      if (user !== false) {
        let fullName = user.firstName
        if (user.secondName !== null && user.secondName.length > 1) {
          fullName += ' ' + user.secondName
        }
        fullName += ' ' + user.firstLastName
        if (user.secondLastName !== null && user.secondLastName.length > 1) {
          fullName += ' ' + user.secondLastName
        }
        return fullName
      }
    },
    debounce: function(val, wait) {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(async () => {
        this.loadUser(val)
      }, wait)
    },
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    activeInactive: function (val, id = null, inventoryCheck) {
      this.products = map(this.products, function(p) {
        if (id) {
          if (p.id === id) {
            p.active = val
            if (inventoryCheck && p.quantity === 0) {
              p.active = false
            }
          }
        } else {
          p.active = val
          if (inventoryCheck && p.quantity === 0) {
            p.active = false
          }
        }
        return p
      })
    },
    updateProductsToBuy: function() {
      this.productsToBuy = map(this.productsToBuy, function(product) {
        product.subtotal = product.cost * product.quantityToBuy
        return product
      })
      this.total = sum(map(this.productsToBuy, 'subtotal'))
    },
    checkInventory() {
      for (let i = 0; i < this.productsToBuy.length; i++) {
        const index = this.products.findIndex(product => product.id === this.productsToBuy[i].id)
        if (index !== -1) {
          const newData = this.products[index]
          newData.quantityToBuy = this.productsToBuy[i].quantityToBuy
          if (this.inventoryCheck) {
            newData.quantityLeft = this.products[index].quantity
          }
          newData.subtotal = this.productsToBuy[i].subtotal
          this.productsToBuy[i] = newData
        }
      }
      this.updateProductsToBuy()
    },
    updateCombosLeft: function() {
      if ((this.userSelected.combos - this.comboAmount) < 0) {
        this.combosLeft = 0
      } else {
        this.combosLeft = this.userSelected.combos - this.comboAmount
      }
    },
    // Load user's info from Card
    loadUser: async function() {
      if (this.cashBoxCheck) {
        await this.getOpenCashBox()
        if (this.cashBoxState.isClosed) {
          return Toast.fire({
            icon: 'warning',
            title: 'La caja está cerrada, por favor solicite apertura.',
          })
        } else if (this.cashBoxState.isPaused) {
          this.codeCardIn = ''
          return Toast.fire({
            icon: 'warning',
            title: 'La caja está pausada.',
          })
        }
      }
      let fields
      if (this.role.includes(consts.rolesText.ESTUDIANTE) || this.role === '') {
        fields = 'id,cc,name,lastName,idGrade,balance,combos,pathAvatar,buylimit'
      } else {
        fields = 'id,cc,name,lastName,idGrade,balance,combos,pathAvatar'
      }
      this.role = ''
      apiClient2.get(`users?fields=${fields}&page=0&per_page=10&q=codeCard!${this.codeCardIn}&credit=${this.creditCheck}`).then(response => {
        if (response.data.data.rows.length > 0) {
          this.activeInactive(true, null, this.inventoryCheck)
          this.userSelected = response.data.data.rows[0]
          this.combosLeft = this.userSelected.combos - this.comboAmount
          this.combosLeftToBuy = this.userSelected.combos
          this.userSelected.grade = this.grades.find((grade) => grade.id === this.userSelected.idGrade)
          let totalInvoices = 0
          if (this.userSelected.controlParental && this.userSelected.controlParental.buyLimit > 0) {
            if (Array.isArray(this.userSelected.invoices) && this.userSelected.invoices.length > 0) {
              for (const invoice of this.userSelected.invoices) {
                totalInvoices += invoice.total
              }
              this.userSelected.totalInvoices = totalInvoices
            } else { this.userSelected.totalInvoices = 0 }
          }
          this.disabledProducts = (this.userSelected.controlParental && this.userSelected.controlParental.products.length > 0) ? this.userSelected.controlParental.products : []
          if (this.userSelected) {
            this.readOnlyUser = true
            this.$refs.products.focus()
          }
        } else {
          this.userSelected = false
        }
        this.search()
      }).catch(e => {
        console.log(e)
        if (e.response.status === 401) {
          window.location = '/login'
        }
      })
    },
    // Getting lastest sales
    loadRecentSales: function() {
      // invoice?fields=id,idUser,total,createdAt
      apiClient.get('invoices').then(response => {
        if (response.data) {
          this.recentSales = response.data.reverse()
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 401) {
          window.location = '/login'
        }
      })
    },
    clearInput: function() {
      this.codeCardIn = ''
      this.role = ''
      this.userSelected = false
      this.readOnlyUser = false
      this.$refs.code.focus()
      this.productsToBuy = []
      this.total = 0
      this.activeInactive(false)
    },
    buyProducts: async function() {
      this.isBuying = true
      const products = this.productsToBuy.map((item) => ({ id: item.id, cost: item.cost, quantityToBuy: item.quantityToBuy, name: item.name }))
      const data = {
        idUser: this.userSelected.id,
        invoice: this.total,
        products,
        boughtCombos: this.comboAmount,
      }
      await apiClient2.post('sales/invoices/', data).then(response => {
        const idInvoice = response.data.data.id
        const idUser = response.data.data.idUser
        const products = JSON.parse(JSON.stringify(this.productsToBuy))
        for (const product of products) {
          product.quantity = product.quantityToBuy
        }
        this.recentSales.shift()
        this.recentSales.push({
          idUser: idUser,
          userName: {
            firstName: this.userSelected.firstName,
            secondName: this.userSelected.secondName,
            firstLastName: this.userSelected.firstLastName,
            secondLastName: this.userSelected.secondLastName,
            cc: this.userSelected.cc,
          },
          idInvoice: idInvoice,
          products: products,
          consecutive: response.data.data.consecutive,
          totalTemp: this.total,
          comboTemp: this.comboAmount,
          combosLeft: this.combosLeft,
          balance: this.userSelected.balance - this.total,
        })
        // Se borra todo lo seleccionado
        this.clearInput()
        this.search(false)
        this.comboAmount = 0
        return response
      }).catch(async e => {
        this.$notification.warning({
          message: 'Notificación',
          description:
          showErrorMessage(e),
        })
        if (e.response) {
          await this.search(true)
          if (this.checkInventory) {
            this.checkInventory()
          }
          this.isBuying = false
        }
      })
      this.isBuying = false
    },
    removeInvoice: async function(sale, code = null) {
      await apiClient2.delete(`sales/invoices/${sale.idInvoice}`, { params: { code } }).then(async response => {
        this.$notification.success({
          message: 'La factura ha sido eliminada y el saldo reembolsado. Nuevo saldo ' + response.data.data.newBalance,
        })
        if (sale.idUser === this.userSelected.id) {
          this.userSelected.balance += sale.totalTemp
          if (this.userSelected.invoices) {
            this.userSelected.invoices.map((invoice, i) => {
              if (invoice.id === sale.idInvoice) {
                this.userSelected.totalInvoices -= sale.totalTemp
                this.userSelected.invoices.splice(i, 1)
              }
            })
          }
        }
        this.recentSales = this.recentSales.filter(item => item.idInvoice !== sale.idInvoice)
        this.search(true)
      }).catch(e => {
        this.$notification.warning({
          message: showErrorMessage(e),
        })
      })
    },
    openModal: function(sale) {
      this.tempSaleData = sale
      this.$bvModal.show('modal-observation')
    },
    // Abre el modal con los filtros de busqueda
    openSearchModal () {
      this.$bvModal.show('modal-search')
    },
    checkRole(sale) {
      const checkRole = this.user.roles.includes(consts.roles.ADMIN) || this.user.roles.includes(consts.roles.ADMIN_RESTAURANTE)
      if (!checkRole) {
        Swal.fire({
          title: `<strong>Digite el código suministrado por el administrador</strong><br>Para eliminar la factura ${sale.consecutive}`,
          input: 'number',
          inputPlaceholder: 'Código',
          inputAttributes: {
            maxlength: 10,
            autocapitalize: 'off',
            autocorrect: 'off',
          },
          icon: 'warning',
          showCancelButton: true,
          allowEnterKey: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
        }).then(async response => {
          if (response.isConfirmed) {
            if (!sale.idInvoice) {
              sale.idInvoice = sale.id
            }
            this.removeInvoice(sale, Number(response.value))
          }
        })
      } else {
        Swal.fire({
          title: 'Confirmar eliminación de factura',
          text: '¿Desea eliminar la factura ' + sale.consecutive + '?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'No.',
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (!sale.idInvoice) {
              sale.idInvoice = sale.id
            }
            this.removeInvoice(sale)
          }
        })
      }
    },
    addObservation: function(sale) {
      if (!sale.idInvoice) {
        sale.idInvoice = sale.id
      }
      if (sale.observation.length < 1 || sale.observation === null) {
        sale.observation = ''
      }
      apiClient.patch('/invoices/' + sale.idInvoice + '/observation', { observation: sale.observation }).then(response => {
        Toast.fire({
          icon: 'success',
          title: 'Observación guardada satisfactoriamente',
        })
        this.$bvModal.hide('modal-observation')
      }).catch(e => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(e),
        })
      })
    },
    editInvoice: function() {
      // apiClient.get('/invoice');
      var dataInvoiceTest = {
        id: 12,
      }
      this.invoiceEdited = dataInvoiceTest
      this.userSelected = dataInvoiceTest.user
      this.productsToBuy = dataInvoiceTest.products
    },
    addProduct: function(p) {
      if (this.disabledProducts && this.disabledProducts.includes(p.id)) {
        this.$notification.warning({
          message: 'Restringido por control parental',
        })
      } else if (this.userSelected) {
        const isProduct = find(this.productsToBuy, function(product) {
          return p.id === product.id
        })

        if (isProduct) {
          this.$notification.warning({
            message: 'El producto ya está seleccionado en la orden',
          })
        } else if (this.inventoryCheck && p.quantity === 0) {
          this.$notification.warning({
            message: `No se encuentran unidades disponibles del producto ${p.name}`,
          })
        } else {
          this.searchProduct = ''
          p.active = false
          const newProduct = p
          newProduct.quantityToBuy = 1
          if (this.inventoryCheck) {
            newProduct.quantityLeft = p.quantity
          }
          newProduct.subtotal = newProduct.quantity * newProduct.cost
          this.productsToBuy.push(newProduct)
          this.updateProductsToBuy()
          this.$nextTick(() => {
            if (this.$refs.products) {
              this.$refs.products.$el.value = ''
            }
          })
          this.$refs.products.focus()
        }
      } else {
        this.$notification.warning({
          message: 'Debe ingresar el código de tarjeta del estudiante',
        })
        this.$refs.code.focus()
      }
    },
    removeProduct: function(product) {
      if (this.inventoryCheck) {
        if (product.quantity > 0) {
          this.activeInactive(true, product.id)
        }
      } else {
        this.activeInactive(true, product.id)
      }
      remove(this.productsToBuy, function(p) {
        return p.id === product.id
      })
      this.updateProductsToBuy()
      this.$refs.products.focus()
    },
    canToBuy: function() {
      const credit = Number(this.userSelected.credit) > 0 ? Number(this.userSelected.credit) : 0
      const balance = this.userSelected.balance > 0 ? this.userSelected.balance + credit : credit
      if (this.userSelected.controlParental && this.userSelected.controlParental.buyLimit > 0) {
        if (this.userSelected.controlParental.buyLimit && this.total <= (this.userSelected.controlParental.buyLimit - this.userSelected.totalInvoices) && this.total <= balance && this.comboAmount <= this.userSelected.combos) {
          return true
        } else {
          return false
        }
      } else if (this.total <= balance && this.comboAmount <= this.userSelected.combos) {
        return true
      } else {
        return false
      }
    },
    enoughProducts: function() {
      for (const product of this.productsToBuy) {
        // const index = this.products.findIndex(product => product.id === productToBuy.id)
        if (product.quantityLeft < product.quantityToBuy) {
          return false
        }
      }
      return true
    },
    checkProducts: function() {
      if (this.productsToBuy.length > 0) {
        return true
      } else if (this.comboAmount > 0) {
        return true
      } else {
        return false
      }
    },
    /* Verifica si existe la categoria del collapse en el producto */
    existCategoryInProduct(product, category) {
      if (product.some(data => data.name === category.name)) {
        return true
      } else {
        return false
      }
    },
    closeSearchModal () {
      this.$bvModal.hide('modal-search')
    },
    productSale(sale) {
      let dev = ''
      if (sale && sale.products.length > 0) {
        for (const product of sale.products) {
          if (Object.prototype.hasOwnProperty.call(product, 'cost')) {
            product.unitCost = product.cost
            delete product.cost
          }
        }
        dev = sale.products.map(product => `
        <tr class="d-flex">
          <td class="w15 text-center">${product.quantity}</td>
          <td class="w65">${product.name}</td>
          <td class="w20 text-center">$ ${product.unitCost * product.quantity}</td>
        </tr>
      `).join('')
      } else if (sale.comboTemp > 0) {
        dev = `<tr class="d-flex">
                <td class="w15 text-center">${sale.comboTemp}</td>
                <td class="w65">${this.comboName}${sale.comboTemp > 1 ? 's' : ''}</td>
                <td class="w20 text-center">$ ${0}</td>
              </tr>`
      }
      return dev
    },
    printInvoice(sale) {
      const userName = this.getFullName(sale.userName)
      const userStorage = JSON.parse(store.get('userData'))
      const school = userStorage.school
      const div = `
          <html>
            <head>
              <title>Imprimir Comprobante</title>
              <style>
                @media print {
                  @page {
                    size: 58mm 300mm;
                    margin: 0;
                    padding: 0;
                    color:  #000000;
                    -webkit-print-color-adjust: exact;
                    color-adjust: exact;
                  }
                  body{
                    margin: 0;
                    padding: 0;
                    color:  #000000;
                  }
                  #print-top{
                    margin-bottom: 5mm !important;
                  }
                  #print-bottom{
                    margin-top: 10mm !important;
                  }
                  .flex-wrap { display: flex; flex-wrap: wrap; }
                  .text-center { text-align: center; }
                  .text-uppercase { text-transform: uppercase; }
                  .font-weight-bold { font-weight: bold; }
                  .d-flex { display: flex; }
                  .flex-column { flex-direction: column; }
                  .w15 { width: 15%; }
                  .w20 {width: 20%}
                  .w65 { width: 65%; }
                  .margin-top-print { margin-top: 4px; }
                  .margin-text { margin: 2mm 0mm; }
                  .container-margin { margin-top: 3px; }
                  .margin-total { margin-top: 5mm; margin-bottom: 5mm; }
                  hr{
                    padding: 0;
                    margin: 2mm 4mm;
                    height: 1px;
                    background-color: #323131;
                  }
                  p,th,td{
                    font-size: 11px;
                  }
                  td{
                    word-wrap: break-word;
                  }
                  .headerInvoice {
                    font-size: 16px;
                  }
                  .name-school{
                    font-size: 18px;
                  }
                  .footer{
                    font-size: 10px;
                    color: #222222;
                  }
                  .text-margin-padding{
                    margin: 0;
                    padding: 0;
                    margin-top: 3px;
                  }
                  .margin-client{
                    padding: 0;
                    margin: 0;
                    font-size: 13px;
                  }
                  .hr-client{
                    padding: 0;
                    margin: 0 4mm 2mm 4mm;
                  }
                  .justify-content-end{
                    justify-content: end;
                  }
                }
              </style>
            </head>
            <body>
              <div id="print" class="my-5">
                <div id="print-top">.</div>
                <div class="headerInvoice d.flex flex-column">
                  <p class="text-margin-padding text-center .name-school text-uppercase font-weight-bold" >${school.name}</p>
                  <p class="text-margin-padding text-center text-capitalize" >${school.address}</p>
                </div>
                <div class="text-center margin-top-print">
                  <p class="text-margin-padding" >Código de venta No.${sale.consecutive}</p>
                  <p class="text-margin-padding" >Fecha y hora</p>
                  <p class="text-margin-padding text-uppercase" >${this.moment(sale.date).format('YYYY-MM-DD hh:mm:ss a')}</p>
                </div>
                <hr>
                       <div class="text-margin-padding text-center">
                  <p class="margin-client">Datos del cliente</p>
                </div>
                <div class="d-flex flex-column text-margin-padding">
                    <p class="text-margin-padding text-center text-capitalize" >${userName}</p>
                    <p class="text-margin-padding text-center" >NIP: ${sale.userName.cc}</p>
                </div>
                <hr>
                <table class="d-flex flex-column">
                  <tr class="d-flex margin-top-print">
                    <th class=" w15 text-center">#</th>
                    <th class="text-center w65">Descripción</th>
                    <th class="w20 text-center">Precio</th>
                  </tr>
                  ${this.productSale(sale)}
                  <tr class="d-flex margin-total justify-content-end">
                    <td class="w65 text-center font-weight-bold" >Total a pagar</td>
                    <td class="w20 text-center">$ ${sale.totalTemp}</td>
                  </tr>
                </table>
                <div class="container-margin">
                  <p class=" font-weight-bold text-center margin-text" >¡GRACIAS POR TU COMPRA!</p>
                </div>
                <div class="footer text-center">
                  Generado por EROO :: ERP para Instituciones Educativas
                  <br>
                  eroo.com.co
                </div>
                <div id="print-bottom">.</div>
              </div>
            </body>
            </html>
          `
      const open = window.open('', '_blank', 'width=500,height=500 top=200,left=400')
      open.document.write(div)
      open.document.close()
      open.print()
      open.close()
    },
    viewProduct(state) {
      this.isGrid = state
      this.$cookies.set('isGrid', this.isGrid)
    },
    productByCategory(category) {
      this.itemProductCategory = []
      if (this.filteredProducts.length > 0) {
        this.filteredProducts.map((product) => {
          product.categories.map((categories) => {
            if (((categories.name).includes(category))) {
              this.itemProductCategory.push(product)
            }
          })
        })
      }
      return this.itemProductCategory
    },
    productFinalByCategory(category) {
      this.itemFinalProductCategory = []
      if (this.filteredProducts.length > 0) {
        this.filteredProducts.map((product) => {
          product.categories.map((categories) => {
            if (((categories.name).includes(category))) {
              this.itemFinalProductCategory.push(product)
            }
          })
        })
      }
      return this.itemFinalProductCategory
    },
    updateCashBox (isClosed) {
      const cashBox = isClosed ? { isClosed } : {
        isPaused: !this.cashBoxState.isPaused,
      }
      apiClient2.patch(`sales/cash-box/${this.cashBoxState.id}`, cashBox).then((response) => {
        isClosed ? this.cashBoxState.isClosed = isClosed : this.cashBoxState.isPaused = !this.cashBoxState.isPaused
        Toast.fire({
          icon: 'success',
          title: response.data.message,
        })
      }).catch((error) => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(error),
        })
      })
    },
    async getOpenCashBox() {
      await apiClient2.get(`sales/cash-box/${this.user.id}/my-box`).then((response) => {
        if (Object.keys(response.data.data).length > 0) {
          this.cashBoxState.isPaused = response.data.data.isPaused
          this.cashBoxState.id = response.data.data.id
          this.cashBoxState.isClosed = response.data.data.endDate ?? false
        } else {
          this.cashBoxState.isClosed = true
        }
      }).catch((error) => {
        Swal.fire('Ooops ocurrio un error', showErrorMessage(error), 'error')
      })
    },
    downloadReportCashBox() {
      const accessToken = store.get('accessToken')
      const endNameReport = moment().format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        AccessToken: accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL_V2 + '/sales/cash-box/report',
        method: 'GET',
        params: {
          startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          idUser: this.user.id,
        },
        responseType: 'blob',
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_caja_${this.user.id}_${endNameReport}.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    },
    clearSearchProuct() {
      this.searchProduct = ''
      this.$refs.products.focus()
    },
  },
  /* Filtra los productos del input */
  computed: {
    ...mapState(['user']),
    filteredProducts: function() {
      const search = this.slugify(this.searchProduct.trim().toLowerCase())
      const filtered = this.products.filter(product => {
        const nameMatch = this.slugify(product.name.trim().toLowerCase()).includes(search)
        const codeMatch = product.barCode ? this.slugify(product.barCode.trim().toLowerCase()).includes(search) : false
        return nameMatch || codeMatch
      })
      const uniqueById = {}
      filtered.forEach(product => {
        if (!uniqueById[product.id]) {
          uniqueById[product.id] = product
        }
      })
      const arrProducts = Object.values(uniqueById)
      if (arrProducts.length === 1 && arrProducts[0].barCode && this.slugify(arrProducts[0].barCode.trim().toLowerCase()) === search) {
        if (this.productsToBuy.some(item => item.id === arrProducts[0].id)) {
          if (this.searchProduct !== '') {
            this.$notification.warning({
              message: 'El producto ya está seleccionado en la orden',
            })
          }
          this.$nextTick(() => {
            this.$refs.products.$el.value = ''
            this.searchProduct = ''
            this.$refs.products.focus()
          })
        } else {
          this.addProduct(arrProducts[0])
          this.$nextTick(() => {
            this.$refs.products.$el.value = ''
            this.searchProduct = ''
            this.$refs.products.focus()
          })
        }
        return { ...this.products }
      }
      return arrProducts
    },
    isDataLoaded: function() {
      if (this.categories && this.products) {
        this.updateProductsQuantity()
        return true
      }
      return false
    },
  },
  created() {
    if (this.$cookies.get('isGrid')) {
      this.isGrid = (this.$cookies.get('isGrid') === 'true')
    }
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
